import { render, staticRenderFns } from "./FormView.vue?vue&type=template&id=826f9d36&scoped=true&"
import script from "./FormView.vue?vue&type=script&lang=js&"
export * from "./FormView.vue?vue&type=script&lang=js&"
import style0 from "./FormView.vue?vue&type=style&index=0&id=826f9d36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826f9d36",
  null
  
)

export default component.exports